import moment from 'moment-timezone';

export default{
    data() {
        return {
            errors: [],
            formSubmitted: false,
            valid: false,
            form: {},
            errors: {}
        }
    },
    methods: {
        setForm(absence) {
            this.clearForm();

            const fechaCDMX = moment.tz('America/Mexico_City');
            const date = fechaCDMX.toDate();

            this.form = {
                id: absence.id ? absence.id : 0,
                type: absence.type ? absence.type : '',
                dates: absence.date ? [absence.date, absence.date] : [date, date],
                observations: absence.observations,
                employee_id: absence.employee_id
            }
        },
        clearForm() {
            const fechaCDMX = moment.tz('America/Mexico_City');
            const date = fechaCDMX.toDate();

            this.form = {
                id: 0,
                type: '',
                dates: [date, date],
                observations: '',
                employee_id: 0
            };

            this.clearErrors();

            this.formSubmitted = false;
            this.showModal = true;
        },
        clearErrors() {
            this.errors = {
                type: false,
                dates: false,
                observations: false,
                employee_id: false
            };
        },
        storeAbsenceValidation() {
            this.formSubmitted = true;
            
            if(this.isStoreValid()){
                
                const zona = 'America/Mexico_City';
                const f1 = moment.tz(this.form.dates[0], zona).startOf('day').format('YYYY-MM-DD');
                const f2 = moment.tz(this.form.dates[1], zona).startOf('day').format('YYYY-MM-DD');

                let params = {
                    employee_id: this.form.employee_id,
                    type: this.form.type,
                    observations: this.form.observations,
                    dates: [f1, f2]
                }

                this.storeAbsence(params);

                this.formSubmitted = true;
                
                this.clearForm();
                this.clearErrors();
            }
        },
        isStoreValid(){
            this.valid = true;

            this.clearErrors();
            
            if(this.form.type.length == 0){
                this.errors.type = "El tipo de ausencia es obligatorio."
                this.valid = false;
            }

            if(this.form.dates.length == 0 || this.form.dates == ''){
                this.errors.dates = "Las fechas a registrar son obligatorias."
                this.valid = false;
            }

            if(this.form.observations.length == 0){
                this.errors.observations = "El motivo de la ausencia es obligatorio."
                this.valid = false;
            }

            if(this.form.employee_id == 0){
                this.errors.employee_id = "El empleado es obligatorio."
                this.valid = false;
            }
            
            return this.valid;
        }
    }
}